export const Constants = {
  ColorGreen: [
    '03CC00',
    '00CC00',
    '00FF00',
    '33FF33',
    '66FF66',
    '0ED145',
    '37C05C',
    '37BB4E',
    '22703F',
    '639F78',
    '54A26D',
    '5C9C74',
    '5A9D7C',
    '5E9C75',
    '5EA779',
    '57A470',
  ],

  ColorRed: [
    'FF0000',
    'CC0000',
    'FF3333',
    'EC1C24',
    'E4CEC7',
    'FFF2EB',
    '874A4B',
    'E39091',
    '824241',
    '844E4B',
    '9C3D43',
    '953E48',
    '01cc00',
  ],

  ColorBlue: [
    '0000CC',
    '0000FF',
    '3333FF',
    '0066CC',
    '0080FF',
    '3F48CC',
    '00A8F3',
    'DFE0F2',
    '4C4E7E',
    '4E4D7F',
    '504D82',
    '504D82',
    '504D81',
    '504E7F',
    '26419C',
    '2449BC',
  ],

  ColorYellow: ['FFFF00', 'FFFF00'],
};

export default Constants;
